export default __webpack_public_path__ + "static/media/contactBgDec3.9ca09cbf.png";